module.exports = __webpack_public_path__ + "static/media/lauren-cohen-icon.41313707.jpg";